import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/compliance";

/**
 * Mobile-only floating "Tap to call" pill.
 * - Visible only on screens below the `md` breakpoint (Tailwind 768px).
 * - Hidden on admin routes.
 * - Slides in once the visitor has scrolled past the hero (~240px) so it
 *   doesn't compete with above-the-fold CTAs.
 */
export default function MobileCallFab() {
    const location = useLocation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 240);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (location.pathname.startsWith("/admin")) return null;

    return (
        <a
            data-testid="mobile-fab-call"
            href={`tel:${COMPANY.phoneTel}`}
            aria-label={`Call ${COMPANY.phone}`}
            className={`fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full border border-brand-gold bg-brand-gold px-5 py-3 text-sm font-semibold uppercase tracking-[0.18em] text-brand-bg shadow-[0_18px_36px_-12px_rgba(0,0,0,0.65)] transition-all duration-300 ease-out active:scale-95 md:hidden ${
                visible
                    ? "translate-y-0 opacity-100"
                    : "pointer-events-none translate-y-3 opacity-0"
            }`}
        >
            <Phone aria-hidden="true" className="h-4 w-4" />
            <span>Call {COMPANY.phone}</span>
        </a>
    );
}
